module.exports = __webpack_public_path__ + "static/media/empty.03c79265.svg";